var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 320 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "filter",
    x: 0,
    y: 0,
    width: 320,
    height: 320,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 40,
    width: 160,
    height: 80,
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,60l-60,-0",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,100l60,-0",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,100l60,-0",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,60l60,-0",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,120l-0,160c-0.301,12.617 -6.557,19.668 -20,20l-80,-0c-13.001,-0.921 -19.284,-7.936 -20,-20l0,-160l120,-0Z",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.463,154.28c10.623,16.111 19.038,32.222 24.167,48.334c6.863,25.045 -1.365,36.479 -24.167,36.25c-22.34,0.534 -33.694,-8.204 -24.167,-36.25c5.669,-14.321 14.102,-30.716 24.167,-48.334Z",
    style: {
      fill: "none",
      stroke: "#333",
      strokeWidth: "15.03px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d5bda3e2af2c13e9865b6a99b5f9f041.svg";
export { ForwardRef as ReactComponent };